<template>
  <Transition><div v-show="showWarning" id="warning">Choose a patient first!</div></Transition>
<ul id="buttons">
  <li v-for="action in buttonData[currentPage]" :key="action.text">
    <button class="action" @click="doAction(action)" :disabled="checkDisabled(action.text)"><img class="icon" v-if="action.image" :src="getImage('./' + action.image)"> {{action.text}}</button>
  </li>
</ul>
</template>

<script>
import GameManager from "@/assets/js/GameManager";

export default {
  name: "buttons",
  data(){
    return {
      currentPage: "TopMenu",
      buttonData: {},
      showWarning: false
    }
  },
  methods: {
    init(){
      console.log("Button Init Called");
      this.currentPage = "TopMenu";
      this.buttonData = this.$store.getters.getButtons;
    },
    doAction(action){
      console.log(action)
      if(action.submenu){
        this.currentPage = action.submenu;
        // TODO: Trigger feedback that the player needs to select a patient first
      } else if(GameManager.selectedSlot >=0 ){
        GameManager.patients[GameManager.selectedSlot].doAction(action);
        //GameManager.saveGame();
      } else {
        this.showWarning = true;
        setTimeout(()=>{this.showWarning = false}, 1500);
      }
    },
    getImage(image){
      return this.$store.getters['getImage'](image);
    },
    checkDisabled(id){
      console.log(GameManager.selectedSlot);
      if(GameManager.selectedSlot > -1){
        return GameManager.patients[GameManager.selectedSlot].isButtonDisabled(id);
      }
      return false;
    }
  },
  created(){
    this.init();
  }
}
</script>

<style scoped lang="less">
@import (reference) "../assets/less/colors";

@media screen and (min-width: 800px) {
  .action{
    min-width: 15em;
    font-size: 1rem;
  }
}
@media screen and (max-width: 799px){
  .action{
    font-size: 0.8rem;
    min-width: 25%;
    //max-height: 33.333%;
  }
  .icon{
    height: 60%;
    max-height: 30px;
  }
}
#buttons{
  list-style: none;
  display: flex;
  justify-content: center;
  align-items: stretch;
  flex-wrap: wrap;
  height: 110px;
  width: 100%;
  background: @lightgray;
  padding: 0;
  margin: 0;
  position: relative;
  z-index: 10;
  li{
    flex: 1;
  }
}

.action{
  height: 100%;
  width: 100%;
  border: 1px solid @darkgray;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1em;
  font-weight: bold;
  background: linear-gradient(to bottom, lighten(@lightgray, 20%), @lightgray);
  cursor: pointer;
  box-sizing: border-box;
  position: relative;
  top: 0;
  &:disabled{
    color: @darkgray;
    background: linear-gradient(to bottom, lighten(@lightgray, 10%), darken(@lightgray, 10%));
  }
  &:active{
    background: linear-gradient(to bottom, lighten(@lightgray, 14%), darken(@lightgray, 6%));
    top: 2px;
  }
}
.icon{
  margin-right: 0.5em;
}
#warning{
  background: @red;
  color: @white;
  position: absolute;
  bottom: 110px;
  font-size: 1.25rem;
  padding: 0.8em;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  z-index: 1;
}
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}
.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
